/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoSpecialBoxLogListSpecialBoxLogData model module.
 * @module model/LogControllerDtoSpecialBoxLogListSpecialBoxLogData
 * @version 1.0
 */
class LogControllerDtoSpecialBoxLogListSpecialBoxLogData {
    /**
     * Constructs a new <code>LogControllerDtoSpecialBoxLogListSpecialBoxLogData</code>.
     * @alias module:model/LogControllerDtoSpecialBoxLogListSpecialBoxLogData
     */
    constructor() { 
        
        LogControllerDtoSpecialBoxLogListSpecialBoxLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoSpecialBoxLogListSpecialBoxLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoSpecialBoxLogListSpecialBoxLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoSpecialBoxLogListSpecialBoxLogData} The populated <code>LogControllerDtoSpecialBoxLogListSpecialBoxLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoSpecialBoxLogListSpecialBoxLogData();

            if (data.hasOwnProperty('specialBoxNo')) {
                obj['specialBoxNo'] = ApiClient.convertToType(data['specialBoxNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('userType')) {
                obj['userType'] = ApiClient.convertToType(data['userType'], 'Number');
            }
            if (data.hasOwnProperty('boxLevel')) {
                obj['boxLevel'] = ApiClient.convertToType(data['boxLevel'], 'Number');
            }
            if (data.hasOwnProperty('playedGameSessionNo')) {
                obj['playedGameSessionNo'] = ApiClient.convertToType(data['playedGameSessionNo'], 'Number');
            }
            if (data.hasOwnProperty('openTransactionNo')) {
                obj['openTransactionNo'] = ApiClient.convertToType(data['openTransactionNo'], 'Number');
            }
            if (data.hasOwnProperty('rewardTransactionNo')) {
                obj['rewardTransactionNo'] = ApiClient.convertToType(data['rewardTransactionNo'], 'Number');
            }
            if (data.hasOwnProperty('createedAt')) {
                obj['createedAt'] = ApiClient.convertToType(data['createedAt'], 'Date');
            }
            if (data.hasOwnProperty('openedAt')) {
                obj['openedAt'] = ApiClient.convertToType(data['openedAt'], 'Date');
            }
            if (data.hasOwnProperty('opened')) {
                obj['opened'] = ApiClient.convertToType(data['opened'], 'Boolean');
            }
            if (data.hasOwnProperty('openCost')) {
                obj['openCost'] = ApiClient.convertToType(data['openCost'], 'Number');
            }
            if (data.hasOwnProperty('rewardXper')) {
                obj['rewardXper'] = ApiClient.convertToType(data['rewardXper'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem1')) {
                obj['rewardItem1'] = ApiClient.convertToType(data['rewardItem1'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem2')) {
                obj['rewardItem2'] = ApiClient.convertToType(data['rewardItem2'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem3')) {
                obj['rewardItem3'] = ApiClient.convertToType(data['rewardItem3'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem4')) {
                obj['rewardItem4'] = ApiClient.convertToType(data['rewardItem4'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem5')) {
                obj['rewardItem5'] = ApiClient.convertToType(data['rewardItem5'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem6')) {
                obj['rewardItem6'] = ApiClient.convertToType(data['rewardItem6'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem7')) {
                obj['rewardItem7'] = ApiClient.convertToType(data['rewardItem7'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem8')) {
                obj['rewardItem8'] = ApiClient.convertToType(data['rewardItem8'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem9')) {
                obj['rewardItem9'] = ApiClient.convertToType(data['rewardItem9'], 'Number');
            }
            if (data.hasOwnProperty('rewardItem10')) {
                obj['rewardItem10'] = ApiClient.convertToType(data['rewardItem10'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoSpecialBoxLogListSpecialBoxLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoSpecialBoxLogListSpecialBoxLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} specialBoxNo
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['specialBoxNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['email'] = undefined;

/**
 * @member {Number} userType
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['userType'] = undefined;

/**
 * @member {Number} boxLevel
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['boxLevel'] = undefined;

/**
 * @member {Number} playedGameSessionNo
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['playedGameSessionNo'] = undefined;

/**
 * @member {Number} openTransactionNo
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['openTransactionNo'] = undefined;

/**
 * @member {Number} rewardTransactionNo
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['rewardTransactionNo'] = undefined;

/**
 * @member {Date} createedAt
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['createedAt'] = undefined;

/**
 * @member {Date} openedAt
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['openedAt'] = undefined;

/**
 * @member {Boolean} opened
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['opened'] = undefined;

/**
 * @member {Number} openCost
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['openCost'] = undefined;

/**
 * @member {Number} rewardXper
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['rewardXper'] = undefined;

/**
 * @member {Number} rewardItem1
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['rewardItem1'] = undefined;

/**
 * @member {Number} rewardItem2
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['rewardItem2'] = undefined;

/**
 * @member {Number} rewardItem3
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['rewardItem3'] = undefined;

/**
 * @member {Number} rewardItem4
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['rewardItem4'] = undefined;

/**
 * @member {Number} rewardItem5
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['rewardItem5'] = undefined;

/**
 * @member {Number} rewardItem6
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['rewardItem6'] = undefined;

/**
 * @member {Number} rewardItem7
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['rewardItem7'] = undefined;

/**
 * @member {Number} rewardItem8
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['rewardItem8'] = undefined;

/**
 * @member {Number} rewardItem9
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['rewardItem9'] = undefined;

/**
 * @member {Number} rewardItem10
 */
LogControllerDtoSpecialBoxLogListSpecialBoxLogData.prototype['rewardItem10'] = undefined;






export default LogControllerDtoSpecialBoxLogListSpecialBoxLogData;

